
import { BusinessUnitAddressEntityDecorator } from './business-unit-address.decorator';
import { BusinessUnitAddress } from './business-unit-address.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class BusinessUnitAddressTypeInfoBase implements CrudTypeInfo<BusinessUnitAddress, number> {
  name = 'Business Unit Address';
  entityDecorator = new BusinessUnitAddressEntityDecorator();
  
  createAuthorities = ['WRITE_BUSINESS_UNIT_ADDRESS'];
  editAuthorities = ['WRITE_BUSINESS_UNIT_ADDRESS'];
  deleteAuthorities = ['WRITE_BUSINESS_UNIT_ADDRESS'];
  viewAuthorities = ['READ_BUSINESS_UNIT_ADDRESS'];
  
  searchRouteBase = ['/businessunitaddress/search'];
  createRouteBase = ['/businessunitaddress/create'];
  editRouteBase = ['/businessunitaddress/edit'];
  viewRouteBase = ['/businessunitaddress/view'];
  
  description(item: BusinessUnitAddress): string {
    return '' +  item.businessUnitAddressId +  ' - ' +  item.description;
  }
}



